<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'ItemCategoryComponent.vue'
}
</script>

<style scoped></style>
